import {
	Table, Popconfirm, Pagination
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	useDebounce
}from 'use-debounce'
import Notifications from '../../../helpers/Notifications'
import {
	reMessageToAdminTypesActions
}from './store/actions'
import moment from "moment"
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AddIcon from '../../../components/Icons/add.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import ReMessageToAdminTypeChangeForm from "./change"
import LocalLoading from '../../../components/Loading/Local'
import ModalAudit from '../ModalAudit'

const ReMessageToAdminType = (props) => {
	const { isModify = false } = props
	const pageSize = 10
	const [visible, setVisible] = useState(false)
	const [visibleModalAudit, setVisibleModalAudit] = useState(false)
	const [record, setRecord] = useState(null)
	const [idRecordAudit, setIdRecordAudit] = useState(null)
	const [count, setCount] = useState(0)
	const [table, setTable] = useState([])
	const [page, setPage] = useState(1)
	const [search, setSearch] = useState(null)
	const [searchValue] = useDebounce(search, 500)
	const { isSending, changed, paged, pagedAudit, countAudit } = useSelector((state) => state.reMessageToAdminTypeReducer)
	const dispatch = useDispatch()

	const getPaged = params => {
		dispatch(reMessageToAdminTypesActions.getPaged(params))
	}
	const getPagedAudit = params => {
		dispatch(reMessageToAdminTypesActions.getPagedAudit(params))
	}
	const getPagedAll = params => {
		dispatch(reMessageToAdminTypesActions.getPagedAll(params))
	}
	const create = params => {
		dispatch(reMessageToAdminTypesActions.create(params))
	}
	const remove = params => {
		dispatch(reMessageToAdminTypesActions.remove(params))
	}
	const update = params => {
		dispatch(reMessageToAdminTypesActions.update(params))
	}
	const restore = params => {
		dispatch(reMessageToAdminTypesActions.restore(params))
	}

	useEffect(() => {
		return () => {
			dispatch(reMessageToAdminTypesActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	useEffect(() => {
		onPaginationChange(1)
	}, [searchValue])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	useEffect(() => {
		if (idRecordAudit){
			getPagedAudit({
				id       : idRecordAudit,
				page     : 1,
				pageSize : pageSize
			})
		}
	}, [idRecordAudit])

	function onPaginationChange(value){
		setPage(value)
		const params = {
			name     : searchValue?.trim(),
			pageSize : pageSize,
			page     : value
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}

	const onPaginationAuditChange = (value) => {
		idRecordAudit && getPagedAudit({
			id   : idRecordAudit,
			page : value,
			pageSize
		})
	}

	const columns = [
		{
			title     : "Код",
			dataIndex : 'code',
			key       : 'code'
		},
		{
			title     : "Название",
			dataIndex : 'name',
			key       : 'name'
		},
		{
			title     : "Дата создания",
			dataIndex : 'createDate',
			key       : 'createDate',
			render    : (date) => moment(date).format("DD.MM.YYYY")
		}
	]

	isModify
		? columns.push({
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img
						src={ UpdateIcon }
						title="Редактировать"
						onClick={ () => {
							setVisible(true)
							setRecord(record)
						} }
					/>
					<Popconfirm
						cancelText="Нет"
						okText="Да"
						placement="left"
						title={ !record.isDeleted ? 'Вы уверены, что хотите удалить данную запись?' : 'Вы уверены, что хотите восстановить данную запись?' }
						onCancel={ (e) => {
							e.stopPropagation()
							return null
						} }
						onConfirm={ (e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						} }
					>
						<img
							src={ !record.isDeleted ? DeleteIcon :RestoreIcon }
							title={ !record.isDeleted ? "Удалить" : "Восстановить" }
						/>
					</Popconfirm>
					<img
						className="audit-icon-svg"
						src={ AuditIcon }
						title="История изменений"
						onClick={ () => {
							setVisibleModalAudit(true)
							setIdRecordAudit(id)
							onPaginationAuditChange(1)
						} }
					/>
				</div>
			)
		})
		: null

	const columnsAudit = [
		{
			dataIndex : "code",
			key       : "code",
			title     : "Код",
			width     : "5%"
		},
		{
			dataIndex : "action",
			key       : "action",
			title     : "Действие",
			width     : "15%"
		},
		{
			dataIndex : "name",
			key       : "name",
			title     : "Название"
		},
		{
			key       : "actionDateTime",
			title     : "Дата",
			dataIndex : "actionDateTime",
			width     : "10%"
		},
		{
			title     : "IP-адрес",
			key       : "ip",
			dataIndex : "ip",
			width     : "10%"
		}
	]

	return (
		<>
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={ 64 }
					placeholder="Введите название/код"
					onChange={ (e) => setSearch(e.target.value) }
				/>
				{ isModify
					? (
						<CustomButton
							className="add-nsi"
							type="green"
							onClick={ () => {
								setRecord(null)
								setVisible(true)
							} }
						>
							<div>
								<img src={ AddIcon } />
								<span>
										Добавить
								</span>
							</div>
						</CustomButton>
					)
					: null }
			</div>
			<Table
				columns={ columns }
				dataSource={ table }
				loading={ { indicator : <LocalLoading />,
					spinning  : isSending } }
				pagination={ false }
				scroll={ { x: 1100 } }
			/>
			{
				count > pageSize &&
          <Pagination
          	showQuickJumper
          	current={ page }
          	pageSize={ pageSize }
          	showSizeChanger={ false }
          	size="small"
          	total={ count }
          	onChange={ onPaginationChange }
          />
			}
			{ isModify &&
        <ReMessageToAdminTypeChangeForm
        	create={ create }
        	record={ record }
        	setRecord={ setRecord }
        	setVisible={ setVisible }
        	update={ update }
        	visible={ visible }
        /> }
			<ModalAudit
				columns={ columnsAudit }
				count={ countAudit }
				data={ pagedAudit }
				setIdRecordAudit={ setIdRecordAudit }
				setPage={ onPaginationAuditChange }
				setVisible={ setVisibleModalAudit }
				visible={ visibleModalAudit }
			/>
		</>
	)
}

export default ReMessageToAdminType